import FleetStatus from './FleetStatus'

export default FleetStatus
